// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"c6e9773e","459":"baec6ecd","787":"9e9f4ffd","818":"402d8b70"}[chunkId] + ".chunk.js";
};